import React, { Component } from 'react'
import styled from 'styled-components'
import gql from 'graphql-tag'
import client from '../../../services/ApolloClient'

const ImageContainer = styled.div`
  border-color: ${({ theme }) => theme.colors.grayContrast};
  border-style: solid;
  border-width: 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  max-height: 300px;
  overflow: hidden;
  width: 100%;
`

const Image = styled.img`
  flex: none;
  max-height: 300px;
  max-width: 300px;
`
class Thumbnail extends Component {

    state = {
        thumbnail_obj: {},
        thumbnail_image: null
      }

    constructor (props) {
        super(props)
      }

    componentDidMount () {
        var key = this.props.thumbKey
        var _this = this
        client.query({
            fetchPolicy: 'no-cache',
            query: gql`
              query FetchThumbnail($key: String!) {
                thumbnail(key: $key) {
                  id
                  key
                  image
                }
              }
            `,
            variables: { key }
          }).then(function(data) {
                _this.setState({thumbnail_obj: data["data"].thumbnail})
            })
            .catch(({ errors }) => (new Error(errors)))
    }
    render () {
        return (
            <ImageContainer>
                <Image src={"data:image/png;base64,"+ this.state.thumbnail_obj.image} />
            </ImageContainer>
        )
    }
}
export default (Thumbnail)



// WEBPACK FOOTER //
// ./src/components/atoms/Thumbnail/Thumbnail.js